<template>
  <VApp>
    <VMain>
      <v-container
        ma-0
        pa-0
        fluid
        class="fill-height"
        style="background-color:#F8FAFC;"
      >
        <v-row align="center" align-content="center">
          <v-col>
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </VMain>
  </VApp>
</template>

<script>
export default {
  name: 'InviteLayout',
};
</script>

<style scoped>

</style>
